var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        {
          attrs: { trigger: "manual", placement: "top", width: "600" },
          model: {
            value: _vm.disabling,
            callback: function ($$v) {
              _vm.disabling = $$v
            },
            expression: "disabling",
          },
        },
        [
          _c("div", [
            _c(
              "h4",
              {
                staticStyle: {
                  "text-align": "center",
                  margin: "10px 0px 20px 0px",
                },
              },
              [_vm._v("\n        Disable Account\n      ")]
            ),
            _vm._v(" "),
            _c("div", [
              _c("label", { staticStyle: { "word-break": "keep-all" } }, [
                _vm._v(
                  "\n          Are you sure you want to disable this account?\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.unlinkDevices,
                    expression: "unlinkDevices",
                  },
                ],
                attrs: { id: "unlink_devices", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.unlinkDevices)
                    ? _vm._i(_vm.unlinkDevices, null) > -1
                    : _vm.unlinkDevices,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.unlinkDevices,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.unlinkDevices = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.unlinkDevices = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.unlinkDevices = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticStyle: { "word-break": "keep-all" },
                  attrs: { for: "unlink_devices" },
                },
                [
                  _vm._v(
                    "\n          All client devices will be unlinked and all users will immediately lose access to the account.\n        "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "text", plain: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    disabled: !_vm.unlinkDevices,
                  },
                  on: { click: _vm.lock },
                },
                [_vm._v("\n        Disable Account\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "customer-field",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _vm.enabled
                ? _c(
                    "el-button",
                    {
                      staticClass: "custom-el-button",
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: {
                        disabled:
                          _vm.locking ||
                          _vm.disabling ||
                          _vm.enabling ||
                          !_vm.userHasPermission({
                            permission: "lock",
                            on: "Customer",
                          }),
                        size: "small",
                        type: "primary",
                        plain: "",
                      },
                      on: { click: _vm.change },
                    },
                    [_vm._v("\n        Lock Account\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-popover",
        {
          attrs: { trigger: "manual", placement: "top", width: "600" },
          model: {
            value: _vm.enabling,
            callback: function ($$v) {
              _vm.enabling = $$v
            },
            expression: "enabling",
          },
        },
        [
          _c(
            "h4",
            {
              staticStyle: {
                "text-align": "center",
                margin: "10px 0px 20px 0px",
              },
            },
            [_vm._v("\n      Enable Account\n    ")]
          ),
          _vm._v(" "),
          _c("div", [
            _c("label", { staticStyle: { "word-break": "keep-all" } }, [
              _vm._v(
                "\n        Are you sure you want to enable this account?\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.accountVerfied,
                  expression: "accountVerfied",
                },
              ],
              attrs: { id: "verified_identity", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.accountVerfied)
                  ? _vm._i(_vm.accountVerfied, null) > -1
                  : _vm.accountVerfied,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.accountVerfied,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.accountVerfied = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.accountVerfied = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.accountVerfied = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticStyle: { "word-break": "keep-all" },
                attrs: { for: "verified_identity" },
              },
              [
                _vm._v(
                  "\n        I certify that I have gone through the appropriate steps to ensure this account's protection and deem it safe to enabled.\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "20px" } },
            [
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "info", plain: "" },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: !_vm.accountVerfied,
                      },
                      on: { click: _vm.lock },
                    },
                    [_vm._v("\n          Enable Account\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "customer-field",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              !_vm.enabled
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: {
                        disabled:
                          _vm.locking ||
                          _vm.disabling ||
                          _vm.enabling ||
                          !_vm.userHasPermission({
                            permission: "lock",
                            on: "Customer",
                          }),
                        size: "small",
                        type: "primary",
                        plain: "",
                      },
                      on: { click: _vm.change },
                    },
                    [_vm._v("\n        Unlock Account\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }